export interface IWithPagination<TData> {
  items: TData[];
  pagination: IPagination;
}

export type IPagination = {
  total: number
  perPage: number
  currentPage: number
  hasNextPage: boolean
  totalPage: number
}

export interface IWithPaginationVars {
  offset: number;
  limit: number;
}

export const QUERY_SORT_PARAMETER_SUFFIX = 'QuerySortParameterInput';
export const QUERY_SORT_PARAMETER_NAME = 'sort';
export const QUERY_FILTER_PARAMETER_SUFFIX = 'QueryFilterParameterInput';
export const QUERY_FILTER_PARAMETER_NAME = 'filter';
export const QUERY_SEARCH_PARAMETER_SUFFIX = 'QuerySearchParameterInput';
export const QUERY_SEARCH_PARAMETER_NAME = 'search';

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>;
};